import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Constants imports
import { URLConstants } from '../../../../_constants/url-constants';
import { APCreditApplicationResultDto } from '../../_models/accounts-payable/ap-credit-application/ap-credit-application-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class APCreditApplicationsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getAPCreditApplications(param) {
        const url = `${URLConstants.ccCBAPBaseApiUrl}/creditapplication${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(APCreditApplicationResultDto, response)));
    }
    unapplyAPCreditApplication(param) {
        const url = `${URLConstants.ccCBAPBaseApiUrl}/creditapplication/unapply`;
        return this.httpClient.put(url, classToPlain(param));
    }
}
APCreditApplicationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function APCreditApplicationsService_Factory() { return new APCreditApplicationsService(i0.ɵɵinject(i1.HttpClient)); }, token: APCreditApplicationsService, providedIn: "root" });
